skrilla.controller('createEntityNotesModalCtrl', function ($scope, searchService, cacheService, modalService, validationService, entityNoteService) {
    $scope.validate = {name: ""};
    entityNoteService.getNoteCategories().then(function (categories) {
        $scope.categories = categories
    });
    $scope.entity = cacheService.getObjectOrElse("entity", modalService.dismissAll);
    $scope.resetNewNote = function () {
        $scope.newNote = {
            category: "",
            content: ""
        };
    }
    $scope.resetNewNote();


    $scope.createNote = function () {
        if (validateForm()) {
            modalService.confirm("Are you sure you'd like to create a new note?", function () {
                searchService.post(`entityNotes/${$scope.entity.type}/${$scope.entity.id}`, $scope.newNote, "Successfully created new note!").then(function () {
                    $scope.resetNewNote();
                    modalService.dismissAll();
                });
            });
        }
    }

    function validateForm() {
        let inputs = [
            validationService.buildFieldValidationObj("category", validationService.isNotEmpty($scope.newNote.category), "Please select a category"),
            validationService.buildFieldValidationObj("content", validationService.isNotEmpty($scope.newNote.content), "Please enter note text"),
        ];
        return validationService.validateForm(inputs, $scope.validate)
    }

});